import { takeLatest, call, put } from 'redux-saga/effects';
import { getSuccess, getFailure, putSuccess, putFailure, putPasswordFailure, putPasswordSuccess, getPatientSuccess, getPatientFailure } from './slice';
import { apiGet, apiPut } from '../../../api/client';

function* getRequest() {
    try {
        const response = yield call(apiGet, 'api/profile');
        yield put(getSuccess(response));
    } catch (error) {
        yield put(getFailure(error?.body?.message || error?.message));
    }
}

function* getPatientRequest() {
    try {
        const response = yield call(apiGet, 'api/patient-profile');
        yield put(getPatientSuccess(response));
    } catch (error) {
        yield put(getPatientFailure(error?.body?.message || error?.message));
    }
}

function* putRequest(action) {
    try {
        const response = yield call(apiPut, 'api/profile', action.payload);
        yield put(putSuccess(response));
    } catch (error) {
        yield put(putFailure(error?.body?.message || error?.message));
    }
}

function* putPasswordRequest(action) {
    try {
        const response = yield call(apiPut, 'api/profile-password', action.payload);
        yield put(putPasswordSuccess(response));
    } catch (error) {
        yield put(putPasswordFailure(error?.body?.message || error?.message));
    }
}

function* saga() {
    yield takeLatest('profile/getRequest', getRequest);
    yield takeLatest('profile/getPatientRequest', getPatientRequest);
    yield takeLatest('profile/putRequest', putRequest);
    yield takeLatest('profile/putPasswordRequest', putPasswordRequest);
}

export default saga;
